<template>
  <div>
    <div class="ng-submission-title">
      <b>{{ title }}</b>
    </div>
    <div class="ng-submission-card">
      <div v-for="file in submission.submissionFiles" :key="file.id">
        <div v-if="file.isValid === false">
          <b>{{ file.fileName }}</b
          ><br />
          <span style="white-space: pre-wrap; color: red">{{
            file.ngReason
          }}</span
          ><br /><br />
        </div>
      </div>

      <div v-if="submission.addedNgReason">
        <v-divider style="border-width: 1.5px"></v-divider>
        <br />
        <span style="white-space: pre-wrap;">{{
          submission.addedNgReason
        }}</span
        ><br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    submission: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="stylus" scoped>
.ng-submission-title
  padding: 5px;
  margin: 0px;
  color: white;
  background-color: red;
  width: 100%;
  font-size: 0.9em;
.ng-submission-card
  background-color: white;
  margin-top: 0px;
  margin-bottom: 7px;
  padding: 15px;
  color: black;
  border: solid 3px red;
</style>
